import React from "react";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  InputGroup
} from "react-bootstrap";
import ContentWrapper from "../../layout/ContentWrapper";
import {  orange,videoblue } from '../../../utils/sitecolors'
import  RankingSettings  from "../../../containers/ranking/RankingSettings"



const RankingSetup = () => (
  

  <ContentWrapper>
    
    <div className="content-heading">Ranking Configuration</div>
           <Row>
                <Col xs={12} md={12} lg={12}>
                  <div className="stacked-filter-panel">
                    <FormGroup controlId="searchby" className="searchby-filter">
                      <FormControl   componentClass="select" placeholder="All"  style={{ minWidth:'130px', borderRadius:'0',minHeight:'38px' }}>
                        <option value='2017'>2017-2018</option>
                        <option value='2018'>2018-2019</option>
                      </FormControl>
                      <FormControl   componentClass="select" placeholder="All"  style={{ minWidth:'120px', borderRadius:'0',minHeight:'38px' }}>
                        <option value='1'>Tier 1</option>
                        <option value='2'>Tier 2</option>
                      </FormControl>
                      <InputGroup>
                   
                        <InputGroup.Button>
                          <Button onClick={this.handleSearch} style={{ color:orange, marginLeft:'-2px', minHeight:'39px' }}>
                            <i className="fa fa-search" aria-hidden="true" />
                          </Button>
                        </InputGroup.Button>   
                        <InputGroup.Button>
                          <Button onClick={this.handleSearch} style={{ backgroundColor:videoblue,color:'white', marginLeft:'-2px', minHeight:'39px' }}>
                            <i className="fa fa-file-excel-o" aria-hidden="true" />{' '}&nbsp;Upload Points File
                          </Button>
                        </InputGroup.Button>                    
                       
                      </InputGroup>
                    </FormGroup>
                  </div>
                </Col>
              </Row>
              <Row>
                <RankingSettings />
              </Row>
  </ContentWrapper>
);



export default RankingSetup;



// WEBPACK FOOTER //
// ./src/components/pages/RankingSetup/index.js